<sigepe-main-layout (sessionTime)="sessionTimeFeedback($event)" [showNotifications]="true" class="template-base" remove-wrapper>
    <!--
        O termo 'slot-main' marca a TAG que deverá acomodar
        o conteúdo principal (corpo) da sua aplicação. Dica: também
        é possível utilizar o slot-main em conjunto com um
        "<router-outlet>" (<router-outlet slot-main></router-outlet>)
        -->
    <router-outlet slot-main></router-outlet>
</sigepe-main-layout>
